export default "__VITE_ASSET__U0qwEEP___"